import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Renders children only for unauthenticated users.
 * Authenticated users are redirected to their respective dashboard.
 */
const PublicOnlyRoute = ({ children }) => {
  const { isAuthenticated, isTeacher, isLoading } = useAuth();

  if (isLoading) return null;

  if (isAuthenticated) {
    const dashboardPath = isTeacher ? '/dashboard/teacher' : '/dashboard/student';
    return <Navigate to={dashboardPath} replace />;
  }

  return children;
};

export default PublicOnlyRoute;
